import type { ReactNode } from "react";

import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { CompanyInfographicsDto, LeadDomainsTableCompanyModel } from "../../types";
import ExpandedRowTableHeaderBase from "../ExpandedRowTableHeaderBase/ExpandedRowTableHeaderBase";

import HeaderContent from "./HeaderContent";
import HeaderContentLoader from "./HeaderContentLoader";

type Props = {
    isLoading: boolean;
    domainsCompanyModel: LeadDomainsTableCompanyModel;
    companyData?: CompanyInfographicsDto;
    onHide(): void;
};

const DomainsTableHeader = ({ isLoading, domainsCompanyModel, companyData, onHide }: Props) => {
    const renderContent = (): ReactNode => {
        if (isLoading) {
            return <HeaderContentLoader />;
        }

        if (is.undefined(companyData)) {
            return null;
        }

        return <HeaderContent companyData={companyData} />;
    };

    return (
        <ExpandedRowTableHeaderBase
            companyData={domainsCompanyModel}
            onHide={onHide}
        >
            {renderContent()}
        </ExpandedRowTableHeaderBase>
    );
};

export default DomainsTableHeader;
